/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: dropdown-component.ts
 *
 * Created by kyang on 2019-11-05.
 */

// TODO: Don't use old scss for styles (button)

function DropdownController (
    this: JS5Object,
    _: JS5Object,
    DropdownService: JS5Object,
    DropdownMultiSelectService: JS5Object,
    DropdownSingleSelectService: JS5Object,
) {

    // Values from component's properties override these values
    // Note: Selection field refers to ngModelCtrl's modelValue instead
    const defaultConfig: JS5Object = {
        prompt: '',
        collection: null,
        labelPath: null,
        labelFunction: null,
        itemDisablePath: 'disabled',
        clearable: false,
        selection: null,
        isMultiSelect: false,
        filter: '',
    };


    //===================//
    // Template Response //
    //===================//

    this.toggleItemsVisibility = () => {
        this.areItemsVisible = !this.areItemsVisible;
        if (this.areItemsVisible) {
            _.invoke(this, 'onDropdownOpened');
        }
    };

    this.onKeyDown = ($event: JS5Object) => {
        if (DropdownService.tryUpdateFilter(this.config, $event)) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        // TODO: Navigate list
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$doCheck = () => {
        if (!this.config) {
            return;
        }
        if (!_.isEmpty(this.configKeysChanged)) {
            // Change object reference to update child components
            this.config = Object.defineProperties({}, Object.getOwnPropertyDescriptors(this.config));
            this.configKeysChanged = {};
        }

        if (this.wereItemsVisible && !this.areItemsVisible) {
            this.config.filter = '';
        }
        this.wereItemsVisible = this.areItemsVisible;
    };

    this.$onInit = () => {
        this.areItemsVisible = false;
        this.wereItemsVisible = false;
        this.configKeysChanged = {};
        this.config = {};

        // Inside get & set functions, "this" == the config object
        let self: JS5Object = this;
        // The config exposes a few properties from this component to its children.
        // If a child updates the config, the parent's property is set.
        //
        // ... Mainly to let the children see when this component's collection changes,
        // and to let the children update the this component's selection property
        //
        // TODO: In Angular 2, check to see if this causes "ExpressionChangedAfterItHasBeenChecked" error.
        //  Tests imply that it won't happen, but if it does, try:
        //      a) Manually invoke changeDetector
        //      b) Rewire services & components to use observables, not the current config
        //          - Should still use one config object to represent the entire dropdown
        Object.defineProperties(
            this.config,
            _.mapValues(defaultConfig, (defaultValue: any, fieldName: string) => {
                if (self[fieldName] === undefined) {
                    self[fieldName] = defaultValue;
                }
                return {
                    enumerable: true,
                    get: () => {
                        if (fieldName === 'selection') {
                            return self.ngModelCtrl.$modelValue;
                        }
                        return self[fieldName];
                    },
                    set: (newValue: any) => {
                        self.configKeysChanged[fieldName] = true;
                        if (fieldName === 'selection') {
                            self.ngModelCtrl.$setViewValue(newValue);
                        } else {
                            self[fieldName] = newValue;
                        }
                    },
                };
            })
        );

        if (this.isMultiSelect) {
            this.selectService = DropdownMultiSelectService;
        } else {
            this.selectService = DropdownSingleSelectService;
        }
    };
}

angular.module('prism-ui.components').component(
    'dropdown',
    {
        bindings: {
            /*
             collection:  (array; required) List of items to pick from.
             modelProp:   (string; required) Name of a property in each item,
                          used to uniquely identify the option.
                          Used to be set as modelValue for single selection
             ngModel:     (any; required) Value == the items selected in the dropdown.
                          Handled by ngModelCtrl.
             */
            collection: '<',
            collectionFilter: '<?', // TODO (Is this necessary?)
            modelProp: '<?', // TODO

            // Component attributes
            clearable: '<?',
            isDisabled: '<?ngDisabled',
            isMultiSelect: '<',
            enableSelectAll: '<?',

            /*
             Selection Responses
             prompt:          (string; required) String to display
                              when no items selected. To changed during runtime, use {{ ... }}
             labelPath:       (string; required) Path to a property in each item,
                              used to display currently selected item in button.
             labelFunction:   (function; optional) Returned value is displayed
                              when this item is selected.
                              Overrides label field behaviour. E.g.
                              labelFunction(item, labelPath)
                              Warning: Function is only called when the selection, or collection changes.
                                  Labels will not be recomputed if the item's properties change.

             itemDisablePath:  (string; optional) Path to a property in each item.
                               If property is set, user cannot interact with this item.
                               If property is set to a blank string, items cannot be disabled.
                               If not specified, defaults to: 'disabled'
             */
            prompt: '@',
            labelPath: '@',
            labelFunction: '=?',
            itemDisablePath: '@?',

            /*
             Display attributes
             attachToBody: (boolean; optional) If true, creates dropdown-list in <body> tag.
                           Otherwise, creates it as a child of this component. Used to display
                           lists that won't get truncated by the dropdown's parent.
                           If not specified, defaults to: false
             maxHeight:    (number; optional) Path to a property in each item,
                           used to display currently selected item in button.
                           If not specified, uses default dropdown height (specified in css).
             */
            btnMinWidth: '<?',
            dropup: '<?',
            attachToBody: '<?',
            maxHeight: '<?',

            /*
             Events
             ngChange: (function; optional) Is invoked every time
                       the selection is modified.
                       Handled by ngModelCtrl.

             */
            // TODO: In Angular 2, replace function calls with Observables?
            onDropdownOpened: '&?',

            // TODO: transclude options HTML

        },
        require: {
            ngModelCtrl: '^ngModel',
        },
        controller: DropdownController,
        templateUrl: 'components/visual/dropdown/dropdown-template.html'
    });
